import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "components/UI/Button";
import { Plus } from "components/UI/Icons";
import { useTranslation } from "localization/localization";
import { resetAutoCountContainersAction, setAutoContainersAction, setTransport } from "store";
import { RootState } from "store";
import { auto_containers } from "utils/data";
import { generateTransport } from "utils/utils";
import { LoadingMode } from "./LoadingModeCard.types";
import { LoadingModeCard } from "./LoadingModeCard";
import { LoadingTransportList } from "./LoadingTransportList";
import s from "./Loading.module.scss";

export const Loading = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { containers, autoContainers, options } = useSelector((state: RootState) => state.root);

  const [mode, setMode] = useState<LoadingMode>(() => (containers.length > 0 ? "manual" : "auto"));

  useEffect(() => {
    if (containers.length > 0) setMode("manual");
  }, [containers.length]);

  const selectAuto = () => {
    setMode("auto");
    dispatch(setTransport([]));
    dispatch(resetAutoCountContainersAction());
    dispatch(setAutoContainersAction(auto_containers));
  };

  const selectManual = () => {
    setMode("manual");
    dispatch(setAutoContainersAction([]));
    dispatch(resetAutoCountContainersAction());
  };

  const addTransport = () => {
    const { lengthUnits, weightUnits } = options;
    const nextContainers = [...containers, generateTransport("20st", lengthUnits, weightUnits)];
    dispatch(setTransport(nextContainers));
    if (autoContainers.length) {
      dispatch(setAutoContainersAction([]));
    }
  };

  return (
    <div className={s.root}>
      <section className={s.panel}>
        <div className={s.header}>
          <h2 className={s.title}>{t("Type of loading")}</h2>
        </div>

        <div className={s.modes}>
          <LoadingModeCard
            title={t("Auto selection")}
            description={t("Automatic calculation and transport unit selection.")}
            tooltip={t("Automatically calculates optimal stuffing across three container types: 20ST, 40ST, and 40HQ")}
            selected={mode === "auto"}
            onSelect={selectAuto}
          />
          <LoadingModeCard
            title={t("Manual")}
            description={t("Select transport unit type manually")}
            tooltip={t("Choose container or truck types yourself and set the quantity for each unit.")}
            selected={mode === "manual"}
            onSelect={selectManual}
          />
        </div>

        {mode === "manual" && (
          <div className={s.actions}>
            <Button type="button" className={s.addTransport} onClick={addTransport}>
              <Plus />
              {t("Add transport")}
            </Button>
          </div>
        )}
      </section>

      {mode === "manual" && <LoadingTransportList />}
    </div>
  );
};
